export enum LeaderboardShowOptions {
    All = 'ALL',
    StepByStep = 'STEP'
  }